module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"path":"/vercel/path0/locales","languages":["it","en"],"defaultLanguage":"it","i18nextOptions":{"ns":["translations"],"defaultNS":"translations","returnObjects":true,"debug":false,"react":{"wait":true},"interpolation":{"escapeValue":false},"nsSeparator":false}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
